import { inject } from '@angular/core';
import { signalStore } from '@ngrx/signals';
import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { BaseEntityContainerStore, BaseEntityStore, BaseEntityTabsStore } from '@processpuzzle/base-entity';
import { ApplicationProperty } from '@processpuzzle/base-widget';
import { CustomApplicationPropertyService } from './custom-application-property.service';

/**
 * Core's `ApplicationPropertyStore` over this application's own service. Not `providedIn: 'root'`: it is bound to
 * core's token in `app.config.ts`, which is what lets the core `like-button` reach this backend with no change to
 * `@processpuzzle/base-widget`.
 */
export const CustomApplicationPropertyStore = signalStore(
  BaseEntityStore<ApplicationProperty>(ApplicationProperty, () => inject(CustomApplicationPropertyService)),
  BaseEntityTabsStore(),
  BaseEntityContainerStore(),
  withDevtools('CustomApplicationProperty'),
);
